module.exports = __webpack_public_path__ + "img/益智.f080d5b8.jpg";